<form #createEquipeForm="ngForm">

    <app-custom-modal #modal title="Criar novo horário" subtitle="Crie um novo horário livre"
        (onCloseClick)="modal.close()" (onSaveClick)="save()" saveLabel="Salvar Horário"
        buttonImage="hgi hgi-stroke hgi-tick-01 icon-color-black" hideCancel [saveDisabled]="createEquipeForm.invalid || (appSession.clinicaId && profissionaisSelecionados.length === 0)">
        <div class="container">
            <div class="mb-4">
                <label for="dia" class="form-label required">Repetir todo(a)</label>
                <div *ngFor="let dia of diasDaSemana">
                    <input type="checkbox" [value]="dia.value" (change)="selectedDia(dia.value)"/>
                    {{ dia.name }}
                </div>
            </div>

            <div class="mb-4">
                <label for="integrantes" class="form-label">Profissionais</label>
                <div *ngIf="appSession.clinicaId" class="input-group mb-4">
                    <div class="input-group-prepend">
                        <span class="input-group-text" id="basic-addon1">
                            <i class="hgi hgi-stroke hgi-search-01"></i>
                        </span>
                    </div>
                    <input type="text" class="form-control" name="keyword" placeholder="Adicione integrantes pelo Nome"
                        (ngModelChange)="atualizarLista($event)" [(ngModel)]="nome">
                </div>

                <div *ngIf="profissionaisFiltrados.length > 0 && appSession.clinicaId"
                    class="card mt-4 scroll-container">
                    <div *ngFor="let profissional of profissionaisFiltrados">
                        <div class="mt-2" (click)="insertProfissional(profissional)"
                            class="row d-flex align-items-center profissional-container">
                            <div class="col-auto">
                                <div class="user-foto-container">
                                    <img src="../../../../../assets/img/user.png" alt="Foto do usuário">
                                </div>
                            </div>
                            <div class="col-auto d-flex flex-column justify-content-start p-0">
                                <p class="nome-profissional">{{ profissional.nome }}</p>
                                <p class="cpf-profissional">{{ profissional.cpf | cpfCnpj}}</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="profissionaisSelecionados.length > 0" class="scroll-container">
                    <div class="mt-4" *ngFor="let profissional of profissionaisSelecionados">
                        <div class="row d-flex align-items-center" (click)="insertProfissional(profissional)">
                            <div class="col-auto d-flex align-items-center">
                                <div class="user-foto-container">
                                    <img src="../../../../../assets/img/user.png" alt="Foto do usuário">
                                </div>
                            </div>
                            <div class="col d-flex align-items-center justify-content-between">
                                <div class="d-flex flex-column">
                                    <p class="nome-profissional m-0">{{ profissional.nome }}</p>
                                    <p class="cpf-profissional m-0">{{ profissional.cpf | cpfCnpj }}</p>
                                </div>
                                <div *ngIf="appSession.clinicaId" class="d-flex align-items-center">
                                    <button class="btn icon icon-danger" title="Remover do grupo"
                                        (click)="removeProfissional(profissional); $event.stopPropagation()">
                                        <i class="hgi hgi-stroke hgi-delete-02"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div class="form-row mb-4">
                <div class="col">
                    <label for="inicio" class="form-label required">Horário Inicio</label>
                    <input type="time" class="form-control" name="inicio" [(ngModel)]="horario.inicio" required
                        #inicioModel="ngModel" #inicioEl id="inicio" />
                    <abp-validation-summary [control]="inicioModel" [controlEl]="inicioEl"></abp-validation-summary>
                </div>
                <div class="col">
                    <label for="fim" class="form-label required">Horário Fim</label>
                    <input type="time" class="form-control" name="fim" [(ngModel)]="horario.fim" required
                        #fimModel="ngModel" #fimEl id="fim" />
                    <abp-validation-summary [control]="fimModel" [controlEl]="fimEl"></abp-validation-summary>
                </div>
            </div>

        </div>
    </app-custom-modal>
</form>